<template>
  <v-form v-model="form_validate_status" ref="form" :loading="loading">
    <v-card max-width="700" class="mx-auto" color="grey-lighten-3">
      <v-layout>
        <CustomAppBar :page="2" :title="$t('info_card.title_page2')" />
        <v-main
          ><v-card-text
            ><v-row>
              <v-col class="v-col-12 v-col-md-12">
                <h5>
                  {{ $t("info_card.thai_citizenID") }} {{ citizen_id }}
                </h5></v-col
              >
              <v-col class="v-col-12 v-col-sm-6">
                <h6>{{ $t("info_card.thai_citizenID_start_date") }}</h6>
                <DateSelectCard
                  v-model="citizen_start_date"
                  :rules="requiredRules"
                  :minDate="getYearsModified(-10)"
                  :maxDate="getYearsModified(10)"
              /></v-col>
              <v-col class="v-col-12 v-col-sm-6">
                <h6>{{ $t("info_card.thai_citizenID_end_date") }}</h6>
                <DateSelectCard
                  v-model="citizen_end_date"
                  :rules="requiredRules"
                  :minDate="getYearsModified(-10)"
                  :maxDate="getYearsModified(10)"
              /></v-col> </v-row></v-card-text
          ><v-divider></v-divider
          ><v-card-text
            ><p>
              {{ $t("info_card.page2_text") }}
            </p>
            <v-row class="pt-3"
              ><v-col class="v-col-12 v-col-sm-6"
                ><h6>{{ $t("info_card.email") }}</h6>
                <EmailForm v-model="email"
              /></v-col>
              <v-col class="v-col-12 v-col-sm-6"
                ><h6>{{ $t("info_card.mobile") }}</h6>
                <MobileForm v-model="mobile"
              /></v-col>
              <v-col class="v-col-12 v-col-sm-6"
                ><h6>{{ $t("info_card.birth_date") }}</h6>
                <DateSelectCard
                  v-model="birthday"
                  :rules="requiredRules"
                  :minDate="getYearsModified(-60)"
                  :maxDate="getYearsModified(-10)" /></v-col
              ><v-col class="v-col-12 v-col-sm-6"
                ><h6>{{ $t("info_card.nation") }}</h6>
                <NationForm v-model="nation_id"
              /></v-col>
              <v-col class="v-col-12"
                ><RaceReligion v-model="race_religion" /></v-col
            ></v-row>
            <v-row class="pt-3">
              <v-col class="v-col-12 v-col-sm-6"
                ><h6>{{ $t("info_card.talent") }}</h6>
                <SpecialSkill v-model="talent_id" /></v-col
              ><v-col class="v-col-12 v-col-sm-6"
                ><h6>{{ $t("info_card.disability") }}</h6>
                <DisabilityForm v-model="disability_id"
              /></v-col>
            </v-row>
            <div v-if="nation_id !== 'TH'">
              <v-divider />
              <v-row class="pt-3">
                <v-col class="v-col-12 v-col-sm-12"
                  ><h3>{{ $t("info_card.foreign_student") }}</h3></v-col
                ><v-col class="v-col-12 v-col-sm-6">
                  <h6>{{ $t("info_card.passport_number") }}</h6>
                  <PassportNumber v-model="passport_number" />
                </v-col>
              </v-row>
              <v-row>
                <v-col class="v-col-12 v-col-sm-6">
                  <h6>{{ $t("info_card.passport_start_date") }}</h6>
                  <DateSelectCard
                    v-model="passport_start_date"
                    :rules="requiredRules"
                    :maxDate="getYearsModified(10)"
                /></v-col>
                <v-col class="v-col-12 v-col-sm-6">
                  <h6>{{ $t("info_card.passport_end_date") }}</h6>
                  <DateSelectCard
                    v-model="passport_end_date"
                    :rules="requiredRules"
                    :maxDate="getYearsModified(10)"
                  />
                </v-col>
              </v-row>
            </div>
            <div v-if="disability_id !== '00'">
              <v-divider />
              <v-row class="pt-3">
                <v-col class="v-col-12 v-col-sm-12"
                  ><h3>{{ $t("info_card.disabilityPlease") }}</h3></v-col
                ><v-col class="v-col-12 v-col-sm-6">
                  <h6>{{ $t("info_card.disabilityId") }}</h6>
                  <v-text-field
                    v-model="disability_number"
                    :rules="requiredRules"
                    variant="outlined"
                    density="compact"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="v-col-12 v-col-sm-6">
                  <h6>{{ $t("info_card.disabilityStartDate") }}</h6>
                  <DateSelectCard
                    v-model="disability_start_date"
                    :rules="requiredRules"
                /></v-col>
                <v-col class="v-col-12 v-col-sm-6">
                  <h6>{{ $t("info_card.disabilityEndDate") }}</h6>
                  <DateSelectCard
                    v-model="disability_end_date"
                    :rules="requiredRules"
                  />
                </v-col>
              </v-row>
            </div>
          </v-card-text>
          <v-divider />
          <v-card-text>
            <h5>{{ $t("info_card.address_registration") }}</h5>
            <v-radio-group
              v-model="home_ThaiOrForeignCountry"
              :rules="requiredRules"
              :mandatory="false"
              row
            >
              <v-row>
                <v-col cols="12" sm="4">
                  <v-radio
                    v-bind:label="$t('info_card.in_thai')"
                    value="inThai"
                  ></v-radio>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-radio
                    v-bind:label="$t('info_card.foreign_country')"
                    value="foreignCountry"
                  ></v-radio>
                </v-col>
              </v-row>
            </v-radio-group>
            <v-row v-if="home_ThaiOrForeignCountry === 'foreignCountry'"
              ><v-col cols="12" sm="6"
                ><h6>{{ $t("info_card.country") }}</h6>
                <NationForm v-model="home_address.country_id" /></v-col
            ></v-row>
            <div v-if="home_ThaiOrForeignCountry === 'inThai'">
              <v-row>
                <v-col cols="12" sm="6">
                  <h6>{{ $t("info_card.house_id") }}</h6>
                  <v-text-field
                    variant="outlined"
                    density="compact"
                    v-model="home_address.house_id"
                    :rules="houseIDrules"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6">
                  <h6>{{ $t("info_card.house_number") }}</h6>
                  <v-text-field
                    v-model="home_address.house_number"
                    :rules="requiredRules"
                    variant="outlined"
                    density="compact"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <h6>{{ $t("info_card.moo") }}</h6>
                  <v-text-field
                    v-model="home_address.moo"
                    :rules="requiredRules"
                    variant="outlined"
                    density="compact"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <h6>{{ $t("info_card.village_name") }}</h6>
                  <v-text-field
                    v-model="home_address.village_name"
                    :rules="requiredRules"
                    variant="outlined"
                    density="compact"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6">
                  <h6>{{ $t("info_card.soi") }}</h6>
                  <v-text-field
                    v-model="home_address.soi"
                    :rules="requiredRules"
                    variant="outlined"
                    density="compact"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <h6>{{ $t("info_card.street") }}</h6>
                  <v-text-field
                    v-model="home_address.street"
                    :rules="requiredRules"
                    variant="outlined"
                    density="compact"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <h6>{{ $t("info_card.province") }}</h6>
                  <v-autocomplete
                    v-model="home_address.province_id"
                    :items="provinces"
                    :item-title="
                      (item) => objectTranslator(item, 'PROVINCE_NAME')
                    "
                    :item-value="(item) => item.PROVINCE_ID"
                    :rules="requiredRules"
                    @update:modelValue="update_home_province"
                    variant="outlined"
                    density="compact"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6">
                  <h6>{{ $t("info_card.district") }}</h6>
                  <v-autocomplete
                    v-model="home_address.district_id"
                    :items="home_filtered_districts"
                    :item-title="
                      (item) => objectTranslator(item, 'DISTRICT_NAME')
                    "
                    :item-value="(item) => item.DISTRICT_ID"
                    :rules="requiredRules"
                    :disabled="home_address.province_id === null"
                    @update:modelValue="update_home_district"
                    variant="outlined"
                    density="compact"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6">
                  <h6>{{ $t("info_card.sub_district") }}</h6>
                  <v-autocomplete
                    v-model="home_address.sub_district_id"
                    :items="home_filtered_subDistricts"
                    :item-title="
                      (item) => objectTranslator(item, 'SUB_DISTRICT_NAME')
                    "
                    :item-value="(item) => item.SUB_DISTRICT_ID"
                    :rules="requiredRules"
                    :disabled="home_address.district_id === null"
                    variant="outlined"
                    density="compact"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
          <v-divider />
          <v-card-text>
            <h5>{{ $t("info_card.address_contact") }}</h5>
            <v-radio-group
              v-model="addressSameOrAddressNew"
              :rules="requiredRules"
              :mandatory="false"
              row
            >
              <v-row>
                <v-col cols="12" sm="4">
                  <v-radio
                    v-bind:label="$t('info_card.address_same')"
                    value="same"
                  ></v-radio>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-radio
                    v-bind:label="$t('info_card.address_new')"
                    value="new"
                  ></v-radio>
                </v-col>
              </v-row>
            </v-radio-group>
            <div v-if="addressSameOrAddressNew === 'new'">
              <v-radio-group
                v-model="contact_ThaiOrForeignCountry"
                :rules="requiredRules"
                :mandatory="false"
                row
              >
                <v-row>
                  <v-col cols="12" sm="4">
                    <v-radio
                      v-bind:label="$t('info_card.in_thai')"
                      value="inThai"
                    ></v-radio>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-radio
                      v-bind:label="$t('info_card.foreign_country')"
                      value="foreignCountry"
                    ></v-radio>
                  </v-col>
                </v-row>
              </v-radio-group>
              <v-row v-if="contact_ThaiOrForeignCountry === 'foreignCountry'"
                ><v-col cols="12" sm="6"
                  ><h6>{{ $t("info_card.country") }}</h6>
                  <NationForm v-model="contact_address.country_id" /></v-col
              ></v-row>
                <v-row v-if="contact_ThaiOrForeignCountry === 'inThai'">
                  <v-col cols="12" sm="6">
                    <h6>{{ $t("info_card.house_number") }}</h6>
                    <v-text-field
                      v-model="contact_address.house_number"
                      :rules="requiredRules"
                      variant="outlined"
                      density="compact"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <h6>{{ $t("info_card.moo") }}</h6>
                    <v-text-field
                      v-model="contact_address.moo"
                      :rules="requiredRules"
                      variant="outlined"
                      density="compact"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <h6>{{ $t("info_card.village_name") }}</h6>
                    <v-text-field
                      v-model="contact_address.village_name"
                      :rules="requiredRules"
                      variant="outlined"
                      density="compact"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6">
                    <h6>{{ $t("info_card.soi") }}</h6>
                    <v-text-field
                      v-model="contact_address.soi"
                      :rules="requiredRules"
                      variant="outlined"
                      density="compact"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <h6>{{ $t("info_card.street") }}</h6>
                    <v-text-field
                      v-model="contact_address.street"
                      :rules="requiredRules"
                      variant="outlined"
                      density="compact"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <h6>{{ $t("info_card.province") }}</h6>
                    <v-autocomplete
                      v-model="contact_address.province_id"
                      :items="provinces"
                      :item-title="
                        (item) => objectTranslator(item, 'PROVINCE_NAME')
                      "
                      :item-value="(item) => item.PROVINCE_ID"
                      :rules="requiredRules"
                      @update:modelValue="update_contact_province"
                      variant="outlined"
                      density="compact"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <h6>{{ $t("info_card.district") }}</h6>
                    <v-autocomplete
                      v-model="contact_address.district_id"
                      :items="contact_filtered_districts"
                      :item-title="
                        (item) => objectTranslator(item, 'DISTRICT_NAME')
                      "
                      :item-value="(item) => item.DISTRICT_ID"
                      :rules="requiredRules"
                      :disabled="contact_address.province_id === null"
                      @update:modelValue="update_contact_district"
                      variant="outlined"
                      density="compact"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <h6>{{ $t("info_card.sub_district") }}</h6>
                    <v-autocomplete
                      v-model="contact_address.sub_district_id"
                      :items="contact_filtered_subDistricts"
                      :item-title="
                        (item) => objectTranslator(item, 'SUB_DISTRICT_NAME')
                      "
                      :item-value="(item) => item.SUB_DISTRICT_ID"
                      :rules="requiredRules"
                      :disabled="contact_address.district_id === null"
                      variant="outlined"
                      density="compact"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
            </div>
          </v-card-text>
          <v-divider />
          <v-card-text> </v-card-text>
          <v-card-text
            ><div
              class="text-end mb-2 text-red"
              v-if="is_saved_before_page === false"
            >
              {{ $t("info.have_not_fill_page_before") }}
            </div>
            <div class="text-end">
              <v-btn color="primary" size="large" class="mr-2" to="/page1"
                >Back</v-btn
              >
              <v-btn
                color="primary"
                size="large"
                :disabled="is_saved_before_page === false"
                @click="saveData"
                >{{ is_lock_kmitl1 === true ? "Next" : "Save & Next" }}</v-btn
              >
            </div></v-card-text
          >
        </v-main>
      </v-layout>
    </v-card>
  </v-form>
</template>

<script>
import { getById } from "@/helper/filter";
import { getYearsModified } from "@/helper/dateTime";
import { objectTranslator } from "@/helper/translator";
import validator from "@/helper/validator";
import CustomAppBar from "@/components/info_cards/CustomAppBar.vue";
import DateSelectCard from "@/components/info_cards/DateSelect.vue";
import EmailForm from "@/components/info_cards/EmailForm.vue";
import MobileForm from "@/components/info_cards/MobileForm.vue";
import NationForm from "@/components/info_cards/NationForm.vue";
import RaceReligion from "@/components/info_cards/RaceReligion.vue";
import PassportNumber from "@/components/info_cards/PassportNumber.vue";
import SpecialSkill from "@/components/info_cards/SpecialSkill.vue";
import DisabilityForm from "@/components/info_cards/DisabilityForm.vue";
import PageProvider from "@/services/page.provider";

const pageService = new PageProvider();

export default {
  name: "PageTwo",
  components: {
    CustomAppBar,
    DateSelectCard,
    EmailForm,
    MobileForm,
    NationForm,
    RaceReligion,
    PassportNumber,
    SpecialSkill,
    DisabilityForm,
  },
  data: () => ({
    form_validate_status: false,
    loading: false,
    is_lock_kmitl1: true,
    is_saved_before_page: false,

    level_id: 1,
    citizen_id: null,
    citizen_start_date: null,
    citizen_end_date: null,
    passport_number: null,
    passport_start_date: null,
    passport_end_date: null,
    birthday: null,
    mobile: null,
    email: null,
    nation_id: "TH",
    race_religion: {
      race_id: null,
      religion_id: null,
    },
    talent_id: null,
    disability_id: null,
    disability_number: null,
    disability_start_date: null,
    disability_end_date: null,

    home_ThaiOrForeignCountry: "inThai", // inThai,foreignCountry
    addressSameOrAddressNew: null,
    contact_ThaiOrForeignCountry: "inThai", // inThai,foreignCountry
    home_address: {
      house_id: null,
      house_number: null,
      moo: null,
      village_name: null,
      soi: null,
      street: null,
      province_id: null,
      district_id: null,
      sub_district_id: null,
      country_id: null,
    },
    contact_address: {
      house_number: null,
      moo: null,
      village_name: null,
      soi: null,
      street: null,
      province_id: null,
      district_id: null,
      sub_district_id: null,
      country_id: null,
    },

    requiredRules: [validator.required],
    houseIDrules: [validator.required, validator.houseID],
  }),

  computed: {
    uid() {
      return this.$store.state.user.surrogated_student_uid;
    },
    surrogated_student_info() {
      return this.$store.state.user.surrogated_student_info;
    },
    subDistricts: function () {
      return this.$store.state.ref.subDistricts;
    },
    districts: function () {
      return this.$store.state.ref.districts;
    },
    provinces: function () {
      return this.$store.state.ref.provinces;
    },
    home_filtered_districts() {
      let data = [];
      if (this.home_address.province_id !== null) {
        data = this.districts.filter((item) =>
          this.home_address.province_id.includes(item.PROVINCE_ID)
        );
      }
      return data;
    },
    home_filtered_subDistricts() {
      let data = [];
      if (this.home_address.district_id !== null) {
        data = this.subDistricts.filter((item) =>
          this.home_address.district_id.includes(item.DISTRICT_ID)
        );
      }
      return data;
    },
    contact_filtered_districts() {
      let data = [];
      if (this.contact_address.province_id !== null) {
        data = this.districts.filter((item) =>
          this.contact_address.province_id.includes(item.PROVINCE_ID)
        );
      }
      return data;
    },
    contact_filtered_subDistricts() {
      let data = [];
      if (this.contact_address.district_id !== null) {
        data = this.subDistricts.filter((item) =>
          this.contact_address.district_id.includes(item.DISTRICT_ID)
        );
      }
      return data;
    },
  },

  methods: {
    getById,
    getYearsModified,
    objectTranslator,
    update_home_province() {
      this.home_address.sub_district_id = null;
      this.home_address.district_id = null;
    },
    update_home_district() {
      this.home_address.sub_district_id = null;
    },
    update_contact_province() {
      this.contact_address.sub_district_id = null;
      this.contact_address.district_id = null;
    },
    update_contact_district() {
      this.contact_address.sub_district_id = null;
    },
    async getData() {
      this.loading = true;
      this.is_lock_kmitl1 =
        this.surrogated_student_info.LOCK_KMITL1 == "0" ? false : true;

      this.level_id = this.surrogated_student_info.LEVEL_ID;

      const data = await pageService.getPage2(this.uid).catch((error) => {
        this.$toast.error(JSON.stringify(error.response.data.message));
      });
      this.citizen_id = data.CITIZEN_ID;
      this.citizen_start_date = new Date(data.CITIZEN_ID_CARD_ISSUE_DATE);
      this.citizen_end_date = new Date(data.CITIZEN_ID_CARD_EXPIRY_DATE);
      this.email = data.EMAIL;
      this.mobile = data.MOBILE;
      this.birthday = new Date(data.BIRTHDAY);
      this.nation_id = data.NATION_ID;
      this.race_religion.race_id = data.RACE_ID;
      this.race_religion.religion_id = data.RELIGION_ID;
      this.talent_id = data.TALENT_ID;
      this.disability_id = data.DISABILITY_ID;

      if (this.disability_id !== "00") {
        this.disability_number = data.DEFORMCARD_ID;
        this.disability_start_date = new Date(data.DEFORMCARD_STARTDATE);
        this.disability_end_date = new Date(data.DEFORMCARD_ENDDATE);
      }
      if (this.nation_id !== "TH") {
        this.passport_number = data.PASSPORT_NUMBER;
        this.passport_start_date = new Date(data.PASSPORT_STARTDATE);
        this.passport_end_date = new Date(data.PASSPORT_ENDDATE);
      }
      if (data.home) {
        this.home_address.country_id = data.home.NATION_ID;
        if (this.home_address.country_id !== "TH") {
          this.home_ThaiOrForeignCountry = "foreignCountry";
        } else {
          this.home_ThaiOrForeignCountry = "inThai";
          this.home_address.house_id = data.home.HOUSE_ID;
          this.home_address.house_number = data.home.HOUSE_NUMBER;
          this.home_address.moo = data.home.MOO;
          this.home_address.village_name = data.home.VILLAGE_NAME;
          this.home_address.soi = data.home.SOI;
          this.home_address.street = data.home.STREET;
          this.home_address.province_id = data.home.PROVINCE_ID;
          this.home_address.district_id = data.home.DISTRICT_ID;
          this.home_address.sub_district_id = data.home.SUB_DISTRICT_ID;
        }
      }
      if (data.contact) {
        this.addressSameOrAddressNew = "new";
        this.contact_address.country_id = data.contact.NATION_ID;
        if (this.contact_address.country_id !== "TH") {
          this.contact_ThaiOrForeignCountry = "foreignCountry";
        } else {
          this.contact_ThaiOrForeignCountry = "inThai";
          this.contact_address.house_id = data.contact.HOUSE_ID;
          this.contact_address.house_number = data.contact.HOUSE_NUMBER;
          this.contact_address.moo = data.contact.MOO;
          this.contact_address.village_name = data.contact.VILLAGE_NAME;
          this.contact_address.soi = data.contact.SOI;
          this.contact_address.street = data.contact.STREET;
          this.contact_address.province_id = data.contact.PROVINCE_ID;
          this.contact_address.district_id = data.contact.DISTRICT_ID;
          this.contact_address.sub_district_id = data.contact.SUB_DISTRICT_ID;
        }
      }
      this.loading = false;
    },
    async saveData() {
      if (this.form_validate_status === true) {
        if (this.is_lock_kmitl1 === false) {
          this.loading = true;

          // convert all date
          const citizen_start_date = this.$dayjs(
            this.citizen_start_date
          ).format("YYYY-MM-DD");
          const citizen_end_date = this.$dayjs(this.citizen_end_date).format(
            "YYYY-MM-DD"
          );
          const birthday = this.$dayjs(this.birthday).format("YYYY-MM-DD");
          const passport_start_date = this.passport_start_date
            ? this.$dayjs(this.passport_start_date).format("YYYY-MM-DD")
            : null;
          const passport_end_date = this.passport_end_date
            ? this.$dayjs(this.passport_end_date).format("YYYY-MM-DD")
            : null;
          const disability_start_date = this.disability_start_date
            ? this.$dayjs(this.disability_start_date).format("YYYY-MM-DD")
            : null;
          const disability_end_date = this.disability_end_date
            ? this.$dayjs(this.disability_end_date).format("YYYY-MM-DD")
            : null;

          let home = {};
          if (this.home_ThaiOrForeignCountry === "foreignCountry") {
            home = {
              HOUSE_ID: null,
              HOUSE_NUMBER: null,
              MOO: null,
              VILLAGE_NAME: null,
              SOI: null,
              STREET: null,
              SUB_DISTRICT_ID: null,
              NATION_ID: this.home_address.country_id,
            };
          } else {
            home = {
              HOUSE_ID: this.home_address.house_id,
              HOUSE_NUMBER: this.home_address.house_number,
              MOO: this.home_address.moo,
              VILLAGE_NAME: this.home_address.village_name,
              SOI: this.home_address.soi,
              STREET: this.home_address.street,
              SUB_DISTRICT_ID: this.home_address.sub_district_id,
              NATION_ID: "TH",
            };
          }

          let contact = {};
          // กรณีที่อยู่ที่ติดต่อได้ ต้องสร้างใหม่
          if (this.addressSameOrAddressNew === "new") {
            //กรณีที่อยู่ที่ติดต่อได้ อยู่ต่างประเทศ
            if (this.contact_ThaiOrForeignCountry === "foreignCountry") {
              contact = {
                HOUSE_ID: null,
                HOUSE_NUMBER: null,
                MOO: null,
                VILLAGE_NAME: null,
                SOI: null,
                STREET: null,
                SUB_DISTRICT_ID: null,
                NATION_ID: this.contact_address.country_id,
              };
            } else {
              //กรณีที่อยู่ที่ติดต่อได้ อยู่ในไทย
              contact = {
                HOUSE_ID: this.contact_address.house_id,
                HOUSE_NUMBER: this.contact_address.house_number,
                MOO: this.contact_address.moo,
                VILLAGE_NAME: this.contact_address.village_name,
                SOI: this.contact_address.soi,
                STREET: this.contact_address.street,
                SUB_DISTRICT_ID: this.contact_address.sub_district_id,
                NATION_ID: "TH",
              };
            }
          } else {
            // กรณีที่อยู่ที่ติดต่อได้ เหมือนกับที่อยู่ตามบัตรประชาชน
            contact = {
              HOUSE_ID: this.home_address.house_id,
              HOUSE_NUMBER: this.home_address.house_number,
              MOO: this.home_address.moo,
              VILLAGE_NAME: this.home_address.village_name,
              SOI: this.home_address.soi,
              STREET: this.home_address.street,
              SUB_DISTRICT_ID: this.home_address.sub_district_id,
              NATION_ID: this.home_ThaiOrForeignCountry === "foreignCountry" ? this.home_address.country_id : "TH",
            };
          }

          const response = await pageService
            .setPage2({
              uid: this.uid,
              CITIZEN_ID_CARD_ISSUE_DATE: citizen_start_date ?? null,
              CITIZEN_ID_CARD_EXPIRY_DATE: citizen_end_date ?? null,
              EMAIL: this.email ?? null,
              MOBILE: this.mobile ?? null,
              BIRTHDAY: birthday ?? null,
              NATION_ID: this.nation_id ?? null,
              PASSPORT_NUMBER: this.passport_number ?? null,
              PASSPORT_STARTDATE: passport_start_date ?? null,
              PASSPORT_ENDDATE: passport_end_date ?? null,
              RACE_ID: this.race_religion.race_id ?? null,
              RELIGION_ID: this.race_religion.religion_id ?? null,
              TALENT_ID: this.talent_id ?? null,
              DISABILITY_ID: this.disability_id ?? null,
              DEFORMCARD_ID: this.disability_number ?? null,
              DEFORMCARD_STARTDATE: disability_start_date ?? null,
              DEFORMCARD_ENDDATE: disability_end_date ?? null,
              home: home,
              contact: contact,
            })
            .catch((error) => {
              this.$toast.error(JSON.stringify(error.response.data.message));
              this.loading = false;
            });
          if (response && response.status) {
            this.$toast.success(this.$t("toast.save_successfully"));
            if (this.level_id == "1") {
              this.$router.push("/page31");
            } else {
              this.$router.push("/page32");
            }
          } else this.$toast.error(this.$t("toast.cannot_save"));
          this.loading = false;
        } else {
          if (this.level_id == "1") {
            this.$router.push("/page31");
          } else {
            this.$router.push("/page32");
          }
        }
      } else {
        this.$toast.error(this.$t("toast.cannot_save"));
      }
    },
  },

  watch: {},
  async created() {
    await this.$store.dispatch("user/getUserInfo");
    this.is_saved_before_page =
      this.surrogated_student_info.ENTERED.includes("1");
    if (this.is_saved_before_page === false) {
      this.$router.push("/main");
    }
    this.$store.dispatch("ref/getSubDistricts");
    this.$store.dispatch("ref/getDistricts");
    this.$store.dispatch("ref/getProvinces");
    this.getData();
  },
};
</script>
<style scoped></style>
